import { render, staticRenderFns } from "./SystemParam.vue?vue&type=template&id=56bf8aca&scoped=true"
import script from "./SystemParam.vue?vue&type=script&lang=js"
export * from "./SystemParam.vue?vue&type=script&lang=js"
import style0 from "./SystemParam.vue?vue&type=style&index=0&id=56bf8aca&prod&scoped=true&lang=css"
import style1 from "./SystemParam.vue?vue&type=style&index=1&id=56bf8aca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf8aca",
  null
  
)

export default component.exports